import aa from 'search-insights';

aa('init', {
  // TODO: Replace these with injected env vars
  appId: 'NOZ1QDJQX7',
  apiKey: '7a90c3feb1020c684066202bacc30669',
});

export default aa;
